import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Legal from "./pages/Legal";
import { SafeBoundary } from "./components/SafeBoundary";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SafeBoundary><Home /></SafeBoundary>} />
        <Route path="/privacy" element={<Legal kind="privacy" />} />
        <Route path="/cookie" element={<Legal kind="cookie" />} />
      </Routes>
      <Toaster theme="dark" position="top-center" />
    </BrowserRouter>
  );
}

export default App;
